$(document).ready(function () {
  $('.announcement-bar-new .announcement-slider').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        speed: 500,
        fade: false
  });
  if($('.banner_list .banner-slide').length > 1){  
    $('.banner_list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true
    });
  }
  $(".reviews-slider").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".product-list.product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".featured-collection-new .product-grid--carousel").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
    ]
  });


  $(".collection_slider_inner").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
  });






});



 // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
    $('.product-list').slick('refresh');
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

    $('.product-list').slick('refresh');
  });
  
  
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


  // mobile Tab
  $(document).on('click','.select-label', function () {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });



// infinite scroll on collection page
document.addEventListener('DOMContentLoaded', function() {
  // Globals so we can clean up
  let infiniteObserver = null;
  let mutationObserver = null;
  let preloadCache = null;
  let isLoading = false;
  let debounceTimer = null;

  // Core init function (creates new IntersectionObserver for the current DOM)
  function initInfiniteScroll() {
    // Clean up existing observer first
    if (infiniteObserver) {
      try { infiniteObserver.disconnect(); } catch(e){/* ignore */ }
      infiniteObserver = null;
    }

    const productGrid = document.querySelector('.collection-listing .product-grid');
    const paginationWrapper = document.querySelector('#PaginationWrapper');
    if (!productGrid || !paginationWrapper) return;

    isLoading = false;
    preloadCache = null;

    // Preload next page
    async function preloadNextPage() {
      const nextLink = paginationWrapper.querySelector('.next-page-link');
      if (nextLink) {
        try {
          const res = await fetch(nextLink.href);
          const txt = await res.text();
          preloadCache = new DOMParser().parseFromString(txt, 'text/html');
        } catch (err) {
          console.warn('Preload failed', err);
          preloadCache = null;
        }
      }
    }

    // IntersectionObserver callback
    infiniteObserver = new IntersectionObserver(async (entries) => {
      const entry = entries[0];
      if (!entry || !entry.isIntersecting || isLoading) return;

      const nextLink = paginationWrapper.querySelector('.next-page-link');
      if (!nextLink) {
        infiniteObserver.disconnect();
        return;
      }

      isLoading = true;
      let htmlDoc = preloadCache;
      if (!htmlDoc) {
        try {
          const res = await fetch(nextLink.href);
          const txt = await res.text();
          htmlDoc = new DOMParser().parseFromString(txt, 'text/html');
        } catch (err) {
          console.error('Fetch next page failed', err);
          isLoading = false;
          return;
        }
      }

      // Append products
      const newProducts = htmlDoc.querySelectorAll('.collection-listing .product-grid > *');
      const newPagination = htmlDoc.querySelector('#PaginationWrapper');
      newProducts.forEach(node => {
        // adopt node into current document (important if node was from parsed doc)
        productGrid.appendChild(document.importNode(node, true));
      });

      if (newPagination) {
        paginationWrapper.innerHTML = newPagination.innerHTML;
      } else {
        // If no pagination returned, remove next link so observer stops
        paginationWrapper.innerHTML = '';
      }

      isLoading = false;
      preloadCache = null;

      // start preloading next-next page for speed
      const nextNext = paginationWrapper.querySelector('.next-page-link');
      if (nextNext) {
        fetch(nextNext.href).then(r => r.text()).then(t => {
          preloadCache = new DOMParser().parseFromString(t, 'text/html');
        }).catch(()=>{ preloadCache = null; });
      }

      // Re-observe the updated pagination wrapper
      try { infiniteObserver.observe(paginationWrapper); } catch (e) {}
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    // start observing the pagination wrapper
    try { infiniteObserver.observe(paginationWrapper); } catch (e) {}
    // start preloading the immediate next page
    preloadNextPage();
  }

  // MutationObserver to watch for any changes in .collection-listing (grid replaced/updated)
  function observeCollectionChanges() {
    const collectionListing = document.querySelector('.collection-listing');
    if (!collectionListing) return;

    // Disconnect old mutation observer
    if (mutationObserver) {
      try { mutationObserver.disconnect(); } catch(e){/* ignore */ }
      mutationObserver = null;
    }

    mutationObserver = new MutationObserver((mutations) => {
      // Debounce rapid changes
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // If product grid exists (either updated or replaced) re-init infinite scroll
        if (document.querySelector('.collection-listing .product-grid')) {
          initInfiniteScroll();
        }
      }, 300); // 300ms debounce
    });

    mutationObserver.observe(collectionListing, { childList: true, subtree: true, attributes: false });
  }

  // Initial run
  initInfiniteScroll();
  observeCollectionChanges();

  // Optional: when user clicks filter controls inside utility-bar__right, wait for DOM changes and re-init (guard)
  const utilityItems = document.querySelectorAll('.utility-bar__right .utility-bar__item');
  if (utilityItems && utilityItems.length) {
    utilityItems.forEach(item => {
      item.addEventListener('click', () => {
        // quickly re-init after filters likely change DOM; MutationObserver will also catch it
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          if (document.querySelector('.collection-listing .product-grid')) initInfiniteScroll();
        }, 500);
      });
    });
  }
});
